import Button from "../../../../components/common/ui/Button";
import { history } from "../../../../_helpers";
import TextInput from "../../../../components/common/ui/Inputs/TextInput";
import RadioInput from "../../../../components/common/ui/Inputs/RadioInput";
import SelectInput from "../../../../components/common/ui/Inputs/SelectInput";
import PasswordInput from "../../../../components/common/ui/Inputs/PasswordInput";
import { useDispatch, useSelector } from "react-redux";
import { memberActions } from "../../../../_store/members.slice";
import memberSchema from "../../../../validation/Admin/memberSchema";
import { useEffect, useState, useMemo } from "react";
import { showToastNotification } from "../../../../components/common/ui/NotificationModal/ToastNotication";
import CustomLoader from "../../../../components/common/ui/Loader";
import { useLocation } from "react-router-dom";
import { masterActions } from "../../../../_store/master.slice";
import { encryptData } from "../../../../utils/encryptDecrypt";
import { CheckBoxInput } from "../../../../components/common/ui/Inputs";
import formatPhoneNumber from "../../../../_helpers/formatPhoneNumber";
import MultiSelectDropdown from "../../../../components/common/ui/Inputs/MultiSelectDropdown";

function CreateOrEditMember() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isPending, setIsPending] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { memberForm, loading } = useSelector((x) => x?.members);

  const {
    rolesList,
    loading: masterLoading,
    getCommitteeListResponse,
  } = useSelector((x) => x?.master);
  // console.log(getCommitteeListResponse);

  const { statusOptions } = useSelector((x) => x?.dropDown);

  const { ActiveStatus } = useSelector((x) => x?.dropDown);

  const memberID = location?.state ? location?.state?.memberID : 0;

  const role =
    memberID !== 0
      ? rolesList?.data
      : rolesList?.data?.filter((member, index) => member?.value !== 2);

  useEffect(() => {
    dispatch(masterActions?.getRolesList());
  }, []);
  useEffect(() => {
    dispatch(masterActions?.getCommitteeList());
  }, []);

  useEffect(() => {
    if (memberID === 0) {
      dispatch(memberActions?.resetMemberForm());
    }
  }, [memberID]);

  useEffect(() => {
    dispatch(memberActions?.resetMemberForm());
    loadMemberData(memberID);
  }, [memberID]);

  const loadMemberData = async (id) => {
    if (!id || id === 0) return;

    try {
      const result = await dispatch(memberActions?.getMemberById(id));
      const res = { ...result?.payload?.data?.user };

      // Add derived field
      res["participateKids"] = res?.organization !== "" ? 1 : 0;

      dispatch(memberActions?.updateMemberForm(res));
    } catch (err) {
      showToastNotification("Failed to get Member data...");
    }
  };

  // const selectedCommittees = useMemo(() => {
  //   debugger;
  //   if (
  //     Array.isArray(getCommitteeListResponse?.data) &&
  //     Array.isArray(memberForm?.committees) &&
  //     getCommitteeListResponse?.data.length > 0
  //   ) {
  //     return getCommitteeListResponse.data.filter((option) =>
  //       memberForm.committees
  //         .map((c) => String(c))
  //         .includes(String(option.value))
  //     );
  //   }
  //   return [];
  //   // }, [getCommitteeListResponse?.data, memberForm?.committees]);
  // }, [memberForm?.committees]);

  const handleChange = (e, select) => {
    const formData = { ...memberForm };

    if (select) {
      formData[select] = e?.value ? e?.value : 2;
      dispatch(memberActions.updateMemberForm(formData));
      return;
    }
    const { name, value, type } = e?.target;
    if (value.startsWith(" ")) return;

    if (name === "firstName" || name === "lastName") {
      const regex = /^[A-Za-z0-9 ]*$/;
      if (!regex.test(value)) {
        return; // block invalid characters
      }
    }
    if (name === "password" || name === "confirmPassword") {
      const regex = /^[A-Za-z0-9!@#$%&*()+=?" _@-]*$/;
      if (!regex.test(value)) {
        return; // block invalid characters
      }
    }

    if (name === "phoneNumber") {
      const target = e?.target || {};
      const selectionStart = target.selectionStart || 0;
      const digitsOnly = value.replace(/\D/g, "");
      const formattedNumber = formatPhoneNumber(digitsOnly);

      requestAnimationFrame(() => {
        const inputElem = document.querySelector(`input[name="phoneNumber"]`);
        if (inputElem) {
          const newCursorPos = calculateNewCursorPosition(
            selectionStart,
            value,
            formattedNumber,
          );
          inputElem.setSelectionRange(newCursorPos, newCursorPos);
        }
      });

      formData[name] = formattedNumber;
      dispatch(memberActions.updateMemberForm(formData));
      return;
    }
    formData[name] =
      type === "radio" ? (value === "true" ? true : false) : value;
    dispatch(memberActions.updateMemberForm(formData));
  };

  const calculateNewCursorPosition = (oldPos, oldValue, newValue) => {
    let rawIndex = 0;
    let newIndex = 0;

    while (rawIndex < oldPos && newIndex < newValue?.length) {
      if (/\d/.test(oldValue[rawIndex])) {
        while (newIndex < newValue?.length && !/\d/.test(newValue[newIndex])) {
          newIndex++;
        }
        newIndex++;
      }
      rawIndex++;
    }
    return newIndex;
  };

  // const handleCommitteChange = (e, select) => {
  //   const selectedIds = e?.map((item) => item.value) || [];
  //   const formData = { ...memberForm };
  //   formData[select] = selectedIds;
  //   dispatch(memberActions.updateMemberForm(formData));
  // };

  const handleCommitteChange = (e, select) => {
    if (!e || (Array.isArray(e) && e.length === 0)) return;
    let selectedIds = [];

    if (Array.isArray(e)) {
      // Multi select case
      selectedIds = e?.map((item) => item?.value);
    } else if (e) {
      // Single select case
      selectedIds = [e.value];
    }

    const formData = { ...memberForm };
    formData[select] = selectedIds;
    dispatch(memberActions.updateMemberForm(formData));
  };

  const handleFormSubmit = async (e) => {
    debugger;
    setIsPending(true);
    e?.preventDefault();
    setErrorMessage({});
    const { error } = memberSchema(memberForm, memberID ? true : false);
    if (error?.details) {
      setIsPending(false);
      const errors = {};
      error.details.forEach((err) => {
        const key = err.path[0];
        if (!errors[key]) {
          errors[key] = err.message;
        }
      });
      setErrorMessage(errors);
      return;
    }
    const encryptPassword = encryptData(memberForm?.password);
    const encryptConfirmPassword = encryptData(memberForm?.confirmPassword);
    const formData = { ...memberForm };
    formData["password"] = encryptPassword;
    formData["confirmPassword"] = encryptConfirmPassword;
    if (memberID) {
      delete formData["password"];
      delete formData["confirmPassword"];
    }
    //API call after validation

    // const isMemberAndChairSame = formData?.committeesAdmin?.some(
    //   (item, index) => {
    //     return formData?.committees?.includes(item?._id);
    //   }
    // );

    // if (isMemberAndChairSame) {
    //   showToastNotification(
    //     "Please select either Chair or Member — a member cannot be added to both fields.",
    //     "error"
    //   );
    //   setIsPending(false);
    //   return;
    // }

    const request =
      memberID === 0
        ? dispatch(memberActions?.createMember(formData))
        : dispatch(memberActions?.updateMember(formData));

    request
      .then((result) => {
        debugger;
        if (result?.payload?.status === 1) {
          setIsPending(false);
          showToastNotification(result?.payload?.message, "success");
          dispatch(memberActions.resetMemberForm());
          history?.navigate("/Admin/Member");
        } else {
          showToastNotification(result?.error?.message, "error");
          setIsPending(false);
        }
      })
      .catch((err) => {
        showToastNotification("Failed to create member", "error");
        setIsPending(false);
      });
  };
  const togglePasswordVisibility = (type) => {
    type === "password"
      ? setShowPassword((prev) => !prev)
      : setShowConfirmPassword((prev) => !prev);
  };

  const handleFormReset = () => {
    setErrorMessage({});
    if (memberID === 0) {
      dispatch(memberActions.resetMemberForm());
    } else {
      loadMemberData(memberID);
    }
  };

  const handleParticipateForKidsOption = (e) => {
    const errors = { ...errorMessage };
    delete errors?.organization;
    setErrorMessage(errors);
    const { name, value } = e?.target;
    const formData = { ...memberForm };
    formData[name] = parseInt(value);
    dispatch(memberActions.updateMemberForm(formData));
  };

  const handlePrivateMember = (e) => {
    debugger;
    const { name, checked } = e?.target;
    const formData = { ...memberForm };
    formData[name] = checked ? 1 : 0;
    dispatch(memberActions.updateMemberForm(formData));
  };

  if (loading || masterLoading) return <CustomLoader />;

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <h1 className="header-color">Member</h1>
        <Button
          label="Back"
          status="reset"
          onClick={() => {
            history?.navigate("/Admin/Member");
            dispatch(memberActions.resetMemberForm());
          }}
        />
      </div>
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color border-dotted p-3 border-bottom">
          {memberID === 0 ? "Create" : "Edit"} Member
        </h1>
        <form
          onSubmit={(e) => {
            handleFormSubmit(e);
          }}
          onReset={(e) => {
            handleFormReset(e);
          }}
          className="p-3 row"
        >
          <div className="row mb-4">
            <div className="col-md-4">
              <TextInput
                label="First Name"
                placeholder="First name"
                name="firstName"
                id="firstName"
                maxLength={25}
                handleChange={(e) => handleChange(e)}
                required
                errorMessage={errorMessage}
                value={memberForm?.firstName}
              />
            </div>
            <div className="col-md-4">
              <TextInput
                label="Last Name"
                placeholder="Last name"
                name="lastName"
                id="lastName"
                maxLength={25}
                handleChange={(e) => handleChange(e)}
                required
                errorMessage={errorMessage}
                value={memberForm?.lastName}
              />
            </div>
            <div className="col-md-4">
              <TextInput
                type="text"
                label="Email"
                placeholder="Email"
                name="email"
                id="email"
                maxLength={100}
                handleChange={(e) => handleChange(e)}
                required
                errorMessage={errorMessage}
                value={memberForm?.email}
              />
            </div>
            <div className="col-md-4">
              <TextInput
                label="Phone Number"
                placeholder="Phone number"
                name="phoneNumber"
                id="phoneNumber"
                handleChange={(e) => handleChange(e)}
                // required
                errorMessage={errorMessage}
                value={memberForm?.phoneNumber}
              />
            </div>
            {memberID === 0 && (
              <>
                <div className="col-md-4">
                  <PasswordInput
                    name="password"
                    ariaLabel="Password"
                    id="Password"
                    label="Password"
                    handleChange={(e) => handleChange(e)}
                    placeholder="Password"
                    required={true}
                    maxlength={25}
                    errorMessage={errorMessage}
                    value={memberForm?.password}
                    showPassword={showPassword}
                    togglePasswordVisibility={() =>
                      togglePasswordVisibility("password")
                    }
                  />
                </div>
                <div className="col-md-4">
                  <PasswordInput
                    name="confirmPassword"
                    id="confirmPassword"
                    label="Confirm Password"
                    handleChange={(e) => handleChange(e)}
                    placeholder="Password"
                    required={true}
                    maxlength={25}
                    ariaLabel="Confirm Password"
                    errorMessage={errorMessage}
                    value={memberForm?.confirmPassword}
                    showPassword={showConfirmPassword}
                    togglePasswordVisibility={() =>
                      togglePasswordVisibility("confirm")
                    }
                  />
                </div>
              </>
            )}
            <div className="col-md-4">
              <SelectInput
                // options={rolesList?.data}
                options={role}
                label="Role"
                name="role"
                handleChange={(e) => handleChange(e, "role")}
                // required
                errorMessage={errorMessage}
                value={memberForm?.role}
                isClearable={memberForm?.role !== 2}
                isDisabled={memberID !== 0 && true}
              />
            </div>

            { }

            <div
              className="col-md-4"
              style={{ display: memberForm?.role === 2 ? "block" : "none" }}
            >
              <label className="form-label font-size-14 form-label-custom-visible m-0">
                Committee Chair
              </label>

              {/* {console.log(memberForm?.committeesAdmin)} */}
              <div className="committee-chair-list">
                {memberForm?.committeesAdmin?.length > 0 &&
                  memberForm?.committeesAdmin?.map((item) => (
                    <span
                      className="white-space-nowrap committee-chair-list-card"
                      key={item}
                      style={{ width: "max-content" }}
                    >
                      {item?.committeeName}
                    </span>
                  ))}
              </div>
            </div>

            {/* )} */}
            {(memberForm?.role === 1 || memberForm?.role === 2) && (
              <div className="col-md-4">
                <MultiSelectDropdown
                  name="committees"
                  options={getCommitteeListResponse?.data || []}
                  displayValue="label"
                  handleChange={(e) => handleCommitteChange(e, "committees")}
                  placeholder="Choose Committee"
                  label="Choose Committee (Member)"
                  errorMessage={errorMessage}
                  // selectedValue={selectedCommittees}
                  selectedValue={
                    Array.isArray(getCommitteeListResponse?.data) &&
                      Array.isArray(memberForm?.committees)
                      ? getCommitteeListResponse.data.filter((option) =>
                        memberForm.committees.includes(option.value),
                      )
                      : []
                  }
                  required={memberForm?.role === 1}
                />
              </div>
            )}
            <div className="col-md-4">
              <RadioInput
                name="participateKids"
                id="participateKids"
                label="Are you participating in the Broward Partnerships for Kids as part of your professional reasons?"
                options={statusOptions}
                selectedValue={memberForm?.participateKids}
                handleChange={(e) => handleParticipateForKidsOption(e)}
              />
            </div>
            {memberForm?.participateKids === 1 && (
              <div className="fs-5 text-gray">
                “If yes, then please add your organization"
              </div>
            )}
            <div className="col-md-12">
              <TextInput
                name="organization"
                id="organization"
                label="Organization"
                placeholder="Organization"
                handleChange={(e) => handleChange(e)}
                value={memberForm?.organization}
                maxLength={256}
                // disabled={memberForm?.participateKids === 0}
                errorMessage={errorMessage}
                required={memberForm?.participateKids === 1}
                ariaLabel="organization"
              />
            </div>
            <div className="col-md-4 mt-4">
              <CheckBoxInput
                label="Private Member"
                name="privateMember"
                id="privateMember"
                handleClick={(e) => handlePrivateMember(e, "privateMember")}
                checked={memberForm?.privateMember}
              />
            </div>
            {/* <div className="col-md-4 mt-4">
              <RadioInput
                name="status"
                id="status"
                label="Status"
                options={ActiveStatus}
                handleChange={(e) => handleChange(e)}
                selectedValue={memberForm?.status}
              />
            </div> */}
          </div>
          <div className="d-flex justify-content-center align-items-center gap-2">
            <Button
              label={`${memberID === 0 ? "Submit" : "Update"}`}
              type="submit"
              status="secondary"
              disabled={isPending}
            />
            <Button label="Reset" type="reset" status="reset" />
          </div>
        </form>
      </div>
    </>
  );
}

export default CreateOrEditMember;
